/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import gql from "graphql-tag";

export const GetUsageQuery = gql`
  query GetUsageQuery {
    usage: getUsage {
      periodStart
      periodEnd
      totalProtections
      appsProtected {
        appId
        time
      }
    }
  }
`;
